import BatteryInfoModal from './BatteryInfoModal';

export default BatteryInfoModal;
